const pad2 = (n) => String(n).padStart(2, '0');

export function formatToDatetimeLocal(d) {
  if (!d || Number.isNaN(new Date(d).getTime())) return '';
  const x = new Date(d);
  return `${x.getFullYear()}-${pad2(x.getMonth() + 1)}-${pad2(x.getDate())}T${pad2(x.getHours())}:${pad2(x.getMinutes())}`;
}

export function isoToDatetimeLocalValue(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return formatToDatetimeLocal(d);
}

export function allDayLocalRangeToIsoFromDatetimeLocal(localStr) {
  const d = new Date(localStr);
  if (Number.isNaN(d.getTime())) return { startsAt: null, endsAt: null };
  const y = d.getFullYear();
  const m = d.getMonth();
  const day = d.getDate();
  const start = new Date(y, m, day, 0, 0, 0, 0);
  const end = new Date(y, m, day, 23, 59, 59, 999);
  return { startsAt: start.toISOString(), endsAt: end.toISOString() };
}

export function allDayFormStringsFromIso(isoStart) {
  if (!isoStart) return { startsLocal: '', endsLocal: '' };
  const d = new Date(isoStart);
  if (Number.isNaN(d.getTime())) return { startsLocal: '', endsLocal: '' };
  const y = d.getFullYear();
  const m = d.getMonth();
  const day = d.getDate();
  const start = new Date(y, m, day, 0, 0, 0, 0);
  const end = new Date(y, m, day, 23, 59, 59, 999);
  return {
    startsLocal: formatToDatetimeLocal(start),
    endsLocal: formatToDatetimeLocal(end),
  };
}

export function datetimeLocalToIso(localStr) {
  if (!localStr) return null;
  const d = new Date(localStr);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

export function formatEventRange(startsAt, endsAt, allDay) {
  if (!startsAt || !endsAt) return '';
  const s = new Date(startsAt);
  const e = new Date(endsAt);
  if (Number.isNaN(s.getTime()) || Number.isNaN(e.getTime())) return '';
  if (allDay) {
    return `${s.toLocaleDateString('pt-BR', { dateStyle: 'short' })} — dia inteiro`;
  }
  return `${s.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })} — ${e.toLocaleString('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  })}`;
}

export function startOfLocalDay(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

export function isSameCalendarDay(a, b) {
  if (a == null || b == null) return false;
  const da = new Date(a);
  const db = new Date(b);
  return (
    da.getFullYear() === db.getFullYear() &&
    da.getMonth() === db.getMonth() &&
    da.getDate() === db.getDate()
  );
}

export function getMonthGridRange(year, monthIndex) {
  const first = new Date(year, monthIndex, 1);
  const last = new Date(year, monthIndex + 1, 0);
  const gridStart = new Date(first);
  gridStart.setDate(first.getDate() - first.getDay());
  gridStart.setHours(0, 0, 0, 0);
  const gridEnd = new Date(last);
  gridEnd.setDate(last.getDate() + (6 - last.getDay()));
  gridEnd.setHours(23, 59, 59, 999);
  return { gridStart, gridEnd };
}

export function buildMonthGridCells(year, monthIndex) {
  const { gridStart } = getMonthGridRange(year, monthIndex);
  const cells = [];
  const cur = new Date(gridStart);
  for (let i = 0; i < 42; i += 1) {
    cells.push(new Date(cur));
    cur.setDate(cur.getDate() + 1);
  }
  return cells;
}

export function eventOverlapsLocalDay(ev, dayDate) {
  if (!ev?.starts_at || !ev?.ends_at) return false;
  const dayStart = startOfLocalDay(dayDate);
  const dayEnd = new Date(dayStart);
  dayEnd.setDate(dayEnd.getDate() + 1);
  const s = new Date(ev.starts_at);
  const e = new Date(ev.ends_at);
  if (ev.all_day) {
    const sy = s.getFullYear();
    const sm = s.getMonth();
    const sd = s.getDate();
    const dy = dayStart.getFullYear();
    const dm = dayStart.getMonth();
    const dd = dayStart.getDate();
    return sy === dy && sm === dm && sd === dd;
  }
  return s < dayEnd && e > dayStart;
}
